import script from "./AdminProducts.vue?vue&type=script&setup=true&lang=js"
export * from "./AdminProducts.vue?vue&type=script&setup=true&lang=js"

import "./AdminProducts.vue?vue&type=style&index=0&id=2571f0ed&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2571f0ed"]])

export default __exports__